import { SET_PREFERENCES, UPDATE_PREFERENCE, REMOVE_PREFERENCE, LIST_PREFERENCES } from "../constants";
import { PreferenceResponse } from "../../types/preference";

const initial_state = {
  loading: false,
  list: [] as PreferenceResponse[]
};

interface stateOptions {
  type: string;
  payload: PreferenceResponse;
}

export default function Preferences(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case LIST_PREFERENCES:
      return {
        ...state,
        list: payload
      };
    
    case SET_PREFERENCES:
      // account calls this on init to populate preferences
      return {
        ...state,
        loading: false,
        list: payload,
      };

    case UPDATE_PREFERENCE:
      // preference calls this later to add contacts to preference
      // normalize contacts to be just ids (to match account payload)
      let payloadContactIds: number[] = payload.contacts ? payload.contacts.map(contact => contact.id) : [];
      let currentPreference = state.list.find(preference => preference.id === payload.id);

      // if preference does not exist, add to list
      if (!currentPreference) {
        currentPreference = payload;
        currentPreference.contacts = payloadContactIds;
        state.list.concat([currentPreference]);

      } else {
        // if preference exists, replace contacts and variables
        state.list = state.list.map(preference => {
          if (preference.id === payload.id) {
            preference = payload;
            preference.contacts = payloadContactIds;
          }
          
          return preference;
        })
      }

      return {
        ...state,
        loading: false,
        list: state.list
      }
    
    case REMOVE_PREFERENCE:
      const removeId = payload.id;

      // find the index
      state.list.map(preference => preference.contacts = preference.contacts ? preference.contacts.filter(contactId => contactId !== removeId) : []);

      return {
        ...state,
        loading: false,
        list: state.list
      };

    default:
      return state;
  }
}
